import React from 'react';
import { CalendarIcon, UsersIcon, MessageSquareIcon, RefreshCwIcon } from 'lucide-react';
export const NoInterviewBand = () => {
  return <section id="no-interview-band" className="py-16 bg-purple-50 relative overflow-hidden" data-id="element-590">
      {/* Background pattern elements */}
      <div className="absolute top-0 right-0 w-80 h-80 bg-purple-100 rounded-full opacity-40 -mr-40 -mt-40" data-id="element-591"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-purple-100 rounded-full opacity-30 -ml-48 -mb-48" data-id="element-592"></div>
      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-593">
        <div className="text-center mb-12" data-id="element-594">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-595">
            Start in 48 hours — no interviews required.
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto" data-id="element-596">
          <div className="bg-white rounded-xl p-6 shadow-sm flex flex-col items-start" data-id="element-597">
            <div className="p-3 bg-primary bg-opacity-10 rounded-full mb-4" data-id="element-598">
              <CalendarIcon className="h-6 w-6 text-primary" data-id="element-599" />
            </div>
            <h3 className="text-xl font-bold mb-2" data-id="element-600">Consult</h3>
            <p className="text-text-secondary" data-id="element-601">
              30-min call with a Senior PM to scope goals and constraints.
            </p>
          </div>
          <div className="bg-white rounded-xl p-6 shadow-sm flex flex-col items-start" data-id="element-602">
            <div className="p-3 bg-primary bg-opacity-10 rounded-full mb-4" data-id="element-603">
              <UsersIcon className="h-6 w-6 text-primary" data-id="element-604" />
            </div>
            <h3 className="text-xl font-bold mb-2" data-id="element-605">Match</h3>
            <p className="text-text-secondary" data-id="element-606">
              We assign your Lead PM within 48 hours (8–15+ yrs).
            </p>
          </div>
          <div className="bg-white rounded-xl p-6 shadow-sm flex flex-col items-start" data-id="element-607">
            <div className="p-3 bg-primary bg-opacity-10 rounded-full mb-4" data-id="element-608">
              <MessageSquareIcon className="h-6 w-6 text-primary" data-id="element-609" />
            </div>
            <h3 className="text-xl font-bold mb-2" data-id="element-610">Kickoff</h3>
            <p className="text-text-secondary" data-id="element-611">
              Your Lead PM embeds in Slack/Jira and ships a 2-week plan.
            </p>
          </div>
          <div className="bg-white rounded-xl p-6 shadow-sm flex flex-col items-start" data-id="element-612">
            <div className="p-3 bg-primary bg-opacity-10 rounded-full mb-4" data-id="element-613">
              <RefreshCwIcon className="h-6 w-6 text-primary" data-id="element-614" />
            </div>
            <h3 className="text-xl font-bold mb-2" data-id="element-615">Swap or refund</h3>
            <p className="text-text-secondary" data-id="element-616">
              Not a fit? Swap anytime in 14 days or get 75% back.
            </p>
          </div>
        </div>
      </div>
    </section>;
};